module.exports = __webpack_public_path__ + "js/1.e06d2f6c.worker.js"